import { render, staticRenderFns } from "./IntelligenceSupplyDemandKpiCards.vue?vue&type=template&id=97704c04&scoped=true"
import script from "./IntelligenceSupplyDemandKpiCards.vue?vue&type=script&lang=js"
export * from "./IntelligenceSupplyDemandKpiCards.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceSupplyDemandKpiCards.vue?vue&type=style&index=0&id=97704c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97704c04",
  null
  
)

export default component.exports